import React, {useState} from "react";
import resetPassword from "assets/Login/resetPassword.png";
import Button from "components/molecules/Button";
import Form from "components/molecules/Form/Form";
import {useForm} from "components/molecules/Form";
import Heading from "components/atoms/Auth/Heading";
import OtpInput from "components/molecules/Otp";
import OnBoardingLayout from "components/atoms/Auth/OnBoardingLayout";
import {useNavigate} from "react-router-dom";
import authService from "services/authService";
import Toast from "components/molecules/Toast";

const EmailOtp = () => {
    const [form] = useForm();
    const navigate = useNavigate();
    const [otpValue, setOtpValue] = useState("");
    const [loading, setLoading] = useState(false);
    const email = sessionStorage.getItem("userEmail");

    const handleSubmit = async () => {
        try {
            setLoading(true);
            const res = await authService.verifyOtp({
                email,
                otp: otpValue,
                websiteSource: process.env.REACT_APP_WEBSITE_SOURCE,
            });
            Toast({type: "success", message: res.message});
            navigate(`/change-password?token=${res.token}`);
        } catch (err) {
            Toast({type: "error", message: err.message});
        } finally {
            setLoading(false);
        }
    };

    const resendOtp = async () => {
        try {
            const res = await authService.forgetPassword({
                email,
                websiteSource: process.env.REACT_APP_WEBSITE_SOURCE,
            });
            Toast({type: "success", message: res.message});
        } catch (err) {
            Toast({type: "error", message: err.message});
        }
    };

    return (
        <OnBoardingLayout img={resetPassword}>
            <Heading heading="Verify OTP!" para="We've sent you the verification code on" paraColoured={email || ""} />
            <Form form={form} onSubmit={handleSubmit}>
                <OtpInput
                    numInputs={4}
                    setOtpValue={value => setOtpValue(value.join(""))}
                    inputBg={"transparent"}
                    onChange={e => console.log(e)}
                    handleResentOtp={() => resendOtp()}
                />
                <Button lg loader={loading}>Confirm OTP</Button>
            </Form>
        </OnBoardingLayout>
    );
};

export default EmailOtp;
